import { Menu } from "primereact/menu";
import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";

import { GANTT_TOOLTIP_ATTRIBUTE } from "./gantt.constants";
import styles from "./gantt.module.scss";
import type { GanttViewProps } from "./types-gantt";

/** Casca do Gantt: o `Tooltip` do conteúdo, o `Menu` único do ⋮ e a tabela com rolagem horizontal. */
export function GanttView({
  testId,
  className,
  style,
  corpoRola,
  rest,
  tooltipRef,
  menuRef,
  menuModel,
  menuTestId,
  scrollerTestId,
  scrollerRef,
  tableStyle,
  tableLabel,
  children,
}: GanttViewProps) {
  return (
    <div
      className={classNames(styles.root, className)}
      style={style}
      data-corpo-rola={corpoRola || undefined}
      data-testid={testId}
      {...rest}
    >
      <Tooltip
        ref={tooltipRef}
        target={`[${GANTT_TOOLTIP_ATTRIBUTE}]`}
        className={styles.tooltip}
        position="top"
        showDelay={150}
      />
      <Menu popup ref={menuRef} model={menuModel} data-testid={menuTestId} />
      <div className={styles.scroller} ref={scrollerRef} data-testid={scrollerTestId}>
        <div className={styles.table} style={tableStyle} role="table" aria-label={tableLabel}>
          {children}
        </div>
      </div>
    </div>
  );
}
